import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  footerButton: {
    position: "absolute",
    bottom: theme.spacing(6),
    left: theme.spacing(6),
    zIndex: 10,
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    padding: theme.spacing(1.5, 3),
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "50px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      transform: "scale(1.05)",
      boxShadow: `0 8px 24px ${theme.palette.primary.main}40`,
    },
  },
}));

export const FooterText = () => {
  const classes = useStyles();

  return (
    <Box className={classes.footerButton}>
      <Button
        href="https://www.linkedin.com/in/imfah33m/"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.button}
      >
        Let's Collaborate
      </Button>
    </Box>
  );
};
